// @flow
import React from "react";
import { FormGroup } from "reactstrap";
import { connect } from "react-redux";
import Section from "../../../components/Section";
import { updateField } from "../../../../redux/actions/configActions";

import * as Constants from "../../../../constants/photoDimensions";
import ImageField from "../../../components/ImageField";

const mapDispatchToProps = { updateField };
const mapStateToProps = state => {
  const { configReducer } = state;
  return {
    config: configReducer.config,
    files: configReducer.files
  };
};

class ARSettings extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      gifOverlayNumber: 0
    };

    // #region event binders
    this.handleChange = this.handleChange.bind(this);
    this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
    this.handleValidatedFileChange = this.handleValidatedFileChange.bind(this);
    // #endregion
  }
  // #region events

  handleChange(event) {
    this.props.updateField({ [event.target.name]: event.target.value });
  }

  handleCheckboxChange(event) {
    event.persist();
    const { config } = this.props;
    this.props.updateField({
      [event.target.name]: !config[event.target.name]
    });
  }

  handleValidatedFileChange(id, image) {
    this.props.updateField({ [id]: image });
  }

  // #endregion
  render() {
    const { config, files } = this.props;

    return (
      <React.Fragment>
        <Section title="Augmented reality settings" subsection>
          <FormGroup row>
            <ImageField
              id="augmentedRealityMask"
              label="AR mask"
              required
              image={files.augmentedRealityMaskFile}
              width={Constants.MaskSide}
              height={Constants.MaskSide}
              onDeleteChange={this.handleCheckboxChange}
              onFileChange={this.handleValidatedFileChange}
            />
          </FormGroup>
        </Section>
      </React.Fragment>
    );
  }
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ARSettings);



// WEBPACK FOOTER //
// ./src/views/Configuration/config-form-sections/config-form-subsections/ARSettings.jsx